// extracted by mini-css-extract-plugin
export default {"root":"prZ8Wc","contentWidth":"bJvaPf"};